// extracted by mini-css-extract-plugin
module.exports = {"content":"Mg","lookName":"Ng","shopTheLookContainer":"Og","productContainer":"Pg","imageContainer":"Qg","mainImage":"Rg"};